import { Link } from "react-router-dom";
import { Users, ShieldCheck, Lightbulb } from "lucide-react";

export default function AboutUs() {
  return (
    <div className="min-h-screen bg-gray-50 text-gray-900">
     

      {/* Hero Section */}
      <header className="flex flex-col justify-center items-center text-center py-24 bg-gradient-to-r from-blue-500 to-purple-500 text-white px-4">
        <h2 className="text-4xl font-bold md:text-5xl">About SkinAI</h2>
        <p className="mt-3 text-lg md:text-xl">Empowering Dermatology with AI-Powered Solutions</p>
      </header>

      {/* Our Mission */}
      <section className="py-12 px-6 max-w-4xl mx-auto text-center">
        <h3 className="text-3xl font-semibold text-gray-800">Our Mission</h3>
        <p className="mt-4 text-gray-600 text-lg">
          At SkinAI, we strive to provide quick, accurate, and AI-driven skin disease detection, assisting doctors and patients in early diagnosis and better healthcare outcomes.
        </p>
      </section>

      {/* Why Choose Us */}
      <section className="py-12 px-6 grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto">
        {[
          { Icon: Users, title: "Expert Team", description: "Built with inputs from top dermatologists and AI researchers." },
          { Icon: ShieldCheck, title: "Trusted & Secure", description: "Ensuring data security with high-end encryption." },
          { Icon: Lightbulb, title: "Innovation", description: "Leveraging AI to revolutionize skin health detection." },
        ].map(({ Icon, title, description }, index) => (
          <div key={index} className="p-6 bg-white rounded-lg shadow-lg flex flex-col items-center text-center">
            <Icon className="h-14 w-14 text-blue-600 mb-3" />
            <h3 className="text-xl font-semibold">{title}</h3>
            <p className="text-gray-600">{description}</p>
          </div>
        ))}
      </section>

      {/* Contact Information */}
      <section className="py-12 text-center bg-gray-100 px-6">
        <h3 className="text-3xl font-semibold text-gray-800">Get in Touch</h3>
        <p className="mt-4 text-gray-600 text-lg">For inquiries, partnerships, or support, contact us at <span className="font-semibold">support@skinai.com</span></p>
      </section>
    </div>
  );
}
